import { Injectable } from '@angular/core';
import { FiBackendService } from '../fi-backend/fi-backend.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import {
    IAIAssistancePrompt,
    IAIChecklist2Model,
    IAIRequestHistoryModel,
    IFiAIAssistanceResponseModel,
} from '@fi-shared/fi-ai-assistance/fi-ai-assistance';
import { FiAIAssistanceType } from '@fi-shared/fi-ai-assistance/fi-a-i-assistance-type';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';

@Injectable()
export class FiAIAssistanceService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    sendMessageToAI(message: string, aiAssistanceType: FiAIAssistanceType) {
        const promise = this.fiBackend.fetchDataPost<IFiAIAssistanceResponseModel>(
            `AIAssistance/AIAssistance/SendMessageToAI?aiAssistanceType=${aiAssistanceType}`,
            {
                Prompt: message,
            },
        );
        return this.fiLoading.trackPromise(promise);
    }

    getChecklistFromAI(message: string, languageId: FiApplicationLanguageType) {
        return this.fiBackend.fetchDataPost<IAIChecklist2Model>(
            `AIAssistance/AIAssistance/GetChecklistFromAI?languageId=${languageId}`,
            {
                Prompt: message,
            },
        );
    }

    getRecentAIRequests(aiAssistanceType: FiAIAssistanceType) {
        const promise = this.fiBackend.fetchData<IAIRequestHistoryModel[]>(
            `AIAssistance/AIAssistance/GetRecentAIRequests?aiAssistanceType=${aiAssistanceType}`,
        );
        return promise;
    }

    getAIPromptSamples(aiAssistanceType: FiAIAssistanceType) {
        const promise = this.fiBackend.fetchData<IAIAssistancePrompt[]>(
            `AIAssistance/AIAssistance/GetAIPromptSamples?aiAssistanceType=${aiAssistanceType}`,
        );
        return this.fiLoading.trackPromise(promise);
    }
}
